import React from 'react';
import logo from '../assets/logo.png';

const Footer = () => {
  return (
    <footer className="footer-section">
      <div className="footer-content">
        <div className="footer-logo">
          <img src={logo} alt="Vertex Group" />
          <h3 className="footer-title">مجموعة فيرتكس</h3>
        </div>
        <p className="footer-address">
          ريف دمشق - داريا - شارع الثورة - مفرق جامع العباس
        </p>
        <a 
          href="https://www.google.com/maps/search/F65M%2BJG,Daryya,syria" 
          target="_blank" 
          rel="noreferrer" 
          className="nav-link"
          style={{ fontSize: '0.9rem', marginBottom: '1.5rem', display: 'inline-block' }}
        >
          عرض الموقع على الخريطة (Plus Code: F65M+5JG)
        </a>
        <div className="footer-bottom">
          &copy; {new Date().getFullYear()} مجموعة فيرتكس. جميع الحقوق محفوظة.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
